import { Stack, Chip, Tooltip } from '@mui/material';

const SEVERITY_COLOR = {
  critical: '#d32f2f',
  high:     '#f57c00',
  medium:   '#f9a825',
  low:      '#388e3c',
};

const FlagChips = ({ flags = [], max = 3 }) => {
  if (!flags.length) return null;
  const visible   = flags.slice(0, max);
  const remaining = flags.length - max;
  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {visible.map((f) => (
        <Tooltip key={f.code} title={f.detail} arrow placement="top">
          <Chip
            label={f.label}
            size="small"
            sx={{
              bgcolor: SEVERITY_COLOR[f.severity] + '22',
              color:   SEVERITY_COLOR[f.severity],
              border:  `1px solid ${SEVERITY_COLOR[f.severity]}55`,
              fontWeight: 600,
              fontSize: '0.6rem',
              height: 18,
              cursor: 'help',
            }}
          />
        </Tooltip>
      ))}
      {remaining > 0 && (
        <Chip label={`+${remaining}`} size="small" sx={{ fontSize: '0.6rem', height: 18 }} />
      )}
    </Stack>
  );
};

export default FlagChips;
